/**
 * Whether a parameter offers an explicit empty ("(Select None)") choice.
 *
 * Mirrors the desktop widget, which gates the empty option solely on
 * `useEmptyAsDefaultValue` (tam `VariablePanelMixin.getUseEmptyValueAsDefaultValue`).
 * `allValuesType` is NOT part of this decision: it only distinguishes the default
 * of a *multi-select* parameter ("all values" vs "empty"), and it defaults to
 * 'empty' on every variable, so keying off it makes practically every
 * single-select LOV render an unwanted "(Select None)" option. tam#37996
 */
export function allowsEmptyValue(variable) {
  return !!(variable && variable.useEmptyAsDefaultValue);
}
